/* SKUMMA by LINTEL PDP: gallery (counter/thumbs), review slider, load more, sticky ATC, every add -> SKU brand cart drawer (never /cart) */
(function () {
  var tr = document.querySelector('[data-sku-track]'), thumbs = document.querySelector('[data-sku-thumbs]'), cnt = document.querySelector('[data-sku-gcount]');
  function go(k) { if (tr) tr.scrollTo({ left: k * tr.clientWidth, behavior: 'smooth' }); }
  function upd() {
    if (!tr) return;
    var n = tr.children.length, i = Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth));
    if (cnt) cnt.textContent = (i + 1) + ' / ' + n;
    if (thumbs) thumbs.querySelectorAll('button').forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
  }
  if (tr) {
    if (thumbs) thumbs.querySelectorAll('button').forEach(function (b, k) { b.addEventListener('click', function () { go(k); }); });
    tr.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
    upd();
  }
  document.querySelectorAll('[data-sku-rs]').forEach(function (c) {
    var t = c.querySelector('.sku-rs__track');
    c.querySelectorAll('.sku-rs__nav button').forEach(function (b) { b.addEventListener('click', function () { t.scrollBy({ left: +b.dataset.d * t.clientWidth * 0.85, behavior: 'smooth' }); }); });
  });
  var more = document.querySelector('[data-sku-more]'), list = document.querySelector('[data-sku-rlist]');
  if (more && list) more.addEventListener('click', function () { list.classList.add('is-all'); more.style.display = 'none'; });
  var form = document.getElementById('sku-buy');
  document.querySelectorAll('[data-sku-top]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault(); var t = document.querySelector('.kaching-bundles') || form;
      if (t) window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 110, behavior: 'smooth' });
    });
  });
  /* Kaching colour choice -> show that colour's hero (image 1 = Blossom Pink, image 4 = Mint Green, image 5 = Midnight Black) */
  document.addEventListener('change', function (e) {
    var s = e.target; if (!s || !s.closest || !s.closest('.kaching-bundles') || s.tagName !== 'SELECT') return;
    var t = (s.options[s.selectedIndex] || {}).text || '';
    if (/mint|green/i.test(t)) go(3); else if (/black/i.test(t)) go(4); else if (/pink/i.test(t)) go(0);
  }, true);
  var st = document.querySelector('[data-sku-sticky]');
  if (st && form && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { st.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); });
    }).observe(form);
  }
  var sa = document.querySelector('[data-sku-sticky-atc]');
  if (sa && form) sa.addEventListener('click', function () {
    if (form.requestSubmit) form.requestSubmit(); else form.querySelector('[type=submit]').click();
  });
})();

/* Add to cart NEVER goes to /cart (Edvin 10-02): every /cart/add form opens the SKU brand cart drawer.
   10-06: Kaching's single bar calls form.submit() directly (no submit event) -> HTMLFormElement.submit is wrapped too, with a 2 s de-dupe. */
(function () {
  if (window.__sku_atc) return; window.__sku_atc = 1;
  function open() { if (window.SKU && window.SKU.openCart) return window.SKU.openCart(); }
  var isAdd = function (f) { return f && f.getAttribute && /\/cart\/add/.test(f.getAttribute('action') || ''); };
  var last = 0;
  function ajaxAdd(f) {
    if (Date.now() - last < 2000) return; last = Date.now();
    var b = f.querySelector('[type=submit]'); if (b) b.disabled = true;
    var fd = new FormData(f), tries = 0;
    (function add() {
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) {
          if (r.ok) { if (b) b.disabled = false; return open(); }
          if (r.status === 422) return r.json().then(function (j) { if (b) b.disabled = false; open(); if (j && j.description) alert(j.description); });
          throw new Error('add ' + r.status);
        })
        .catch(function () { if (++tries < 5) return setTimeout(add, 1000 * tries); if (b) b.disabled = false; open(); alert('Sorry, that did not go through - please tap Add to cart again.'); });
    })();
  }
  var nativeSubmit = HTMLFormElement.prototype.submit;
  HTMLFormElement.prototype.submit = function () { if (isAdd(this)) return ajaxAdd(this); return nativeSubmit.apply(this, arguments); };
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!isAdd(f) || e.defaultPrevented) return;
    e.preventDefault(); ajaxAdd(f);
  }, false);
})();
